import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stripHtmlTags'
})
export class StripHtmlTagsPipe implements PipeTransform {

  /**
   * strip all html-tags from string
   * @param value
   */
  transform(value: string): string {
    if (value === null || value === undefined) {
      return '';
    } else {
      value = value.replaceAll('<br>', ' ');
      value = value.replaceAll('  ', ' ');
      return value.replace(/<[^>]*>/g, '');
    }
  }

}
